import * as ActionTypes from '../../actions'
import {
    Action,
    LoginStatus
} from "../../types";

let defaultState = {
    isLogged: false
};

export default function(state: LoginStatus = defaultState, action: Action) {
    const { type } = action;

    switch (type){
        case ActionTypes.LOGIN_SUCCESSFUL:{
            window.localStorage["isLogged"]= true;
            return {
                isLogged: true,
            };
        }
                
        case ActionTypes.LOGOUT_SUCCESSFUL:{
            window.localStorage["isLogged"]= false;
            return {
                isLogged: false,
            }; 
        }
              
        default: {
            return state;
        }
    }   
};



// WEBPACK FOOTER //
// ./src/reducers/login/login.ts